export enum CourseStatus {
  Enrolled = 1,
  Active,
  Completed,
  Failed,
  Locked,
  Canceled,
  Dropped,
  Expired  
}
